import ObjectCache from './CacheService';
import LogicBaseMessageApi from '../server/LogicBaseMessageApi';
import UserAccount from '../UserAccount';
import LogicBaseMessage from '../../models/logicbasemessage';
import { normalizeMessengerAttachments } from '../../utils/imagePaste';

class LogicBaseMessageCache extends ObjectCache {
  api = LogicBaseMessageApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseMessage(
      results._id,
      results.ct,
      results.ut,
      results.c,
      results.s,
      results.t,
      normalizeMessengerAttachments(results.a),
      results.et,
    );
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseMessageCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
